import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import DoneIcon from '../../../../packages/common/shared-ui/src/icons/DoneIcon';
import SpreadsheetMobileCreateRow from '../SpreadsheetMobileCreateRow';
import { formatWeek } from '../formatWeek';

// Original class: editSaveIssueButton
const StyledEditSaveIssueButton = styled(IconButton)(theme => ({
  '&.MuiButtonBase-root': {
    backgroundColor: '#6270D0',
  },
}));

const SpreadsheetMobileEditIssue = ({
  query,
  setQuery,
  formattedIssues,
  intl,
  timeType,
  timeTypes,
  setEditedFormattedIssues,
  handleSaveSpreadsheet,
}) => {
  const currentIssue = formattedIssues[query.editIssue] || {};
  const currentWeek =
    Object.keys(currentIssue).length !== 0
      ? currentIssue[
          timeType === timeTypes.MAIN_HOURS ? 'weekDays' : 'overTimeWeekDays'
        ]
      : [];
  const isSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('lg'),
  );
  const [weekSum, setWeekSum] = useState(
    currentWeek.reduce((acc, day) => acc + day.hours, 0),
  );

  const handleSaveMobileRow = useCallback(async () => {
    const saveResult = await handleSaveSpreadsheet();
    setQuery({ ...query, editIssue: null });
  }, [handleSaveSpreadsheet, query, setQuery]);

  useEffect(() => {
    if (!formattedIssues[query.editIssue] || !isSmallScreen) {
      return setQuery({ editIssue: null });
    }
  }, [formattedIssues, isSmallScreen, query.editIssue, setQuery]);

  return (
    <Grid container direction='column'>
      <Grid
        container
        wrap='nowrap'
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          <Typography
            variant='h3'
            sx={{
              fontWeight: 700,
            }}
          >
            <FormattedMessage id='spreadsheet_issue_edit' />
          </Typography>
          <Typography variant='h5'>
            {dayjs(query.start).format('DD MMMM YYYY')} -{' '}
            {dayjs(query.end).format('DD MMMM YYYY')}
          </Typography>
        </Box>
        <StyledEditSaveIssueButton disableRipple onClick={handleSaveMobileRow}>
          <DoneIcon width={24} height={24} viewBox='0 0 24 24' />
        </StyledEditSaveIssueButton>
      </Grid>
      <Grid
        container
        direction='column'
        sx={{
          padding: 4,
        }}
      >
        <Box
          sx={{
            marginBottom: 2.5,
          }}
        >
          <Typography variant='h6'>
            <FormattedMessage id='spreadsheet_table_project' />
          </Typography>
          <Typography variant='h4'>{currentIssue?.projectName}</Typography>
        </Box>
        <Box
          sx={{
            marginBottom: 2.5,
          }}
        >
          <Typography variant='h6'>
            <FormattedMessage id='spreadsheet_table_issues' />
          </Typography>
          <Typography variant='h4'>{currentIssue?.issueName}</Typography>
        </Box>
      </Grid>
      {currentWeek.map(day => {
        return (
          <SpreadsheetMobileCreateRow
            key={day.date}
            day={day}
            intl={intl}
            currentWeek={currentWeek}
            currentIssue={currentIssue}
            setWeekSum={setWeekSum}
            timeType={timeType}
            timeTypes={timeTypes}
            setEditedFormattedIssues={setEditedFormattedIssues}
            type='edit'
          />
        );
      })}
      <Box
        sx={{
          marginY: 2.5,
        }}
      >
        <Typography variant='h4'>
          <FormattedMessage id='spreadsheet_week_sum' /> {weekSum}{' '}
          <FormattedMessage id='hour' />
        </Typography>
      </Box>
    </Grid>
  );
};

export default SpreadsheetMobileEditIssue;
